import useMediaQuery from '@material-ui/core/useMediaQuery';

// see https://getbootstrap.com/docs/4.0/layout/overview/
const BREAKPOINT_MEDIUM = 768;

export default function useMobileWidth() {
  return !useMediaQuery(`(min-width:${BREAKPOINT_MEDIUM}px)`);
}
